'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://pacific-brushlands-63550.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client2.js